// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8592) return "static/chunks/common-ac4d0f837b28e0fb.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6484":"9b73ea1acc483b8b","7017":"ce12c347d59e6ef5"}[chunkId] + ".js";
};